import AccordionItem from './partials/AccordionItem';

/**
 * @param {number[]} activeItems
 * @param {number} id
 * @returns {boolean}
 */
const isItemOpen = (activeItems, id) => activeItems.includes(id);

/**
 * @param {AccordionProps} props
 * @returns {React.ReactElement} The rendered component
 */
const Accordion = ({ items, activeItem, activeItems, onChange }) => {
  return (
    <>
      {items.map((item, idx) => (
        <AccordionItem
          key={idx}
          description={item.description}
          isOpen={idx === activeItem || isItemOpen(activeItems || [], idx || 0)}
          clicked={() => onChange(idx)}
        >
          {item.column}
        </AccordionItem>
      ))}
    </>
  );
};

export default Accordion;
